import React from 'react';
import PropTypes from 'prop-types';
import './FormGroup.css';

/**
 * FormGroup — a titled group of fields: a fieldset whose legend is an H5
 * ("Om dig", "Leveransadress"), an optional note under it, the fields in a
 * column.
 */
const FormGroup = ({ legend, note, className = '', children, ...rest }) => (
  <fieldset className={['ds-form-group', className].filter(Boolean).join(' ')} {...rest}>
    <legend className="ds-form-group__legend typo-h5">{legend}</legend>
    {note && <p className="ds-form-group__note typo-body-sm">{note}</p>}
    {children}
  </fieldset>
);

FormGroup.propTypes = {
  legend: PropTypes.node.isRequired,
  /** A line under the legend that reads with it */
  note: PropTypes.node,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default FormGroup;
